import UsersService from '../../../services/users.service';
import store from '@/store';
import router from '@/router';

const compare = (a, b) => {
    return a.name.localeCompare(b.name);
};

/**
 * Load country options
 */
const loadCountriesOptions = async () => {
    try {
        // Si ya tenemos los paises cargados no hacemos nada
        const countriesOptionsStored = store.getters['getCountriesOptions'];
        if (countriesOptionsStored && countriesOptionsStored.length) return;

        const { data } = await UsersService.getCountries();

        const vueInstance = router.app;
        const countriesWithLiterals = data.countries_info.map(x => {
            return {
                name: vueInstance.$t(`countries.${x.country_key}`),
                key: x.country_key,
                phone_prefix: x.phone_prefix,
                has_crs: x.has_crs
            };
        });

        // Buscamos el objeto que tiene el literal ESP para eliminarlo
        const espLiteral = countriesWithLiterals.find(x => x.key === 'ESP');

        // Eliminamos ESP del array
        const countriesWihoutSpain = countriesWithLiterals.filter(x => x.key !== 'ESP');

        // Ordenamos el array alfabéticamente
        countriesWihoutSpain.sort(compare);

        // Concatenación del objecto ESP con el resto de paises
        const countriesOptions = [espLiteral, ...countriesWihoutSpain];
        store.dispatch('setCountriesOptions', countriesOptions);
    } catch (error) {
        console.error(`Error loadCountriesOptions: ${error}`);
        // vueInstance.$bvToast.toast(
        //     'Error loadCountriesOptions',
        //     `Error loading country options: ${error}`
        // );
    }
};

export default loadCountriesOptions;
